module.exports = require("tough-cookie");


//////////////////
// WEBPACK FOOTER
// external "tough-cookie"
// module id = 5
// module chunks = 1